import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import classnames from 'classnames';

import { Link } from 'react-router-dom';
import { IconButton, Modal, Typography } from '@material-ui/core';

import { dateWithOptionalTime } from '../../youwell-common/dateUtils';
import { CloseIcon, CompletedIcon, NotDoneIcon } from '../../common/icons';
import { PageLayout } from '../../common/components';
import { getElementLink, getBreadCrumb } from '../../common/breadcrumbUtil';

const styles = theme => ({
    root: {
        boxShadow: theme.shadows[1],
    },
    modules: {
        display: 'flex',
        flexDirection: 'column',
        borderTop: theme.youwell.borders.normal,
        borderTopColor: theme.palette.secondary.main,
        borderTopWidth: 4,
    },
    task: {
        padding: theme.spacing(2, 2),
        display: 'flex',
        alignItems: 'center',
        borderBottom: theme.youwell.borders.normal,
    },
    completed: {

    },
    unavailable: {

    },
    name: {
        flex: '1 1 auto',

        '$unavailable &': {
            color: theme.palette.text.secondary,
        },
    },
    moduleDate: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    preIcon: {
        width: 40,
    },
    done: {
        color: theme.youwell.colors.green,
    },
    notDone: {
        color: theme.youwell.colors.red,
    },
    noTasksAssigned: {
        padding: theme.spacing(4),
        margin: theme.spacing(2),
    },
    disabled: {
        pointerEvents: 'none',
        cursor: 'default',
        opacity: 0.7,
    },
});

class TaskGroup extends React.Component {
    state = {
        modalOpen: false,
    }

    clickElement = element => (e) => {
        if (element.disabled) {
            e.preventDefault();
            this.setState({ modalOpen: true });
        }
    }

    closeModal = () => {
        this.setState({ modalOpen: false });
    }

    render() {
        const {
            classes, translate, currentProgram, match, clientConfig,
        } = this.props;

        const { elementGroup } = match.params;

        return (
            <PageLayout
                breadcrumb={getBreadCrumb(translate(`patientProgramElementGroups.${elementGroup}`), translate, clientConfig)}
            >
                <div className={classes.root}>
                    {currentProgram.groupedElements[elementGroup].length > 0 ? (
                        <>
                            <div className={classes.modules}>
                                {currentProgram.groupedElements[elementGroup].map(element => (
                                    <Link
                                        key={element.id}
                                        className={classnames(classes.task, { [classes.completed]: element.completed, [classes.unavailable]: element.disabled })}
                                        to={getElementLink(element)}
                                        onClick={this.clickElement(element)}
                                    >
                                        <div className={classes.preIcon}>
                                            <>
                                                {element.completed && <CompletedIcon className={classes.done} />}
                                                {!element.completed && new Date(element.startTime) <= new Date() && <NotDoneIcon className={classes.notDone} />}
                                            </>
                                        </div>
                                        <Typography className={classes.name}>
                                            {element.name}
                                        </Typography>
                                        {element.isNotStarted && (
                                            <Typography variant="caption" color="textSecondary" className={classes.moduleDate}>
                                                {dateWithOptionalTime(element.startTime)}
                                            </Typography>
                                        )}
                                    </Link>
                                ))}
                            </div>
                        </>
                    ) : (
                        <Typography align="center" color="textSecondary" className={classes.noTasksAssigned} display="block">
                            {translate('noTasksAssigned')}
                        </Typography>
                    )}
                </div>
                <Modal
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                    open={this.state.modalOpen}
                    onClose={this.closeModal}
                >
                    <div className={classes.modal}>
                        <IconButton onClick={this.closeModal} className={classes.closeIcon} aria-label={translate('close')}>
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="subtitle1" id="modal-title" gutterBottom>
                            {translate('scheduledTasks.elementNotAvailable')}
                        </Typography>
                        <Typography id="modal-description">
                            {translate('scheduledTasks.elementNotAvailableDescription')}
                        </Typography>
                    </div>
                </Modal>
            </PageLayout>
        );
    }
}

TaskGroup.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    clientConfig: PropTypes.object.isRequired,
    currentProgram: PropTypes.object.isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            elementGroup: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    clientConfig: state.auth.clientConfig,
    currentProgram: state.programStore.currentProgram,
});


export default connect(mapStateToProps)(withStyles(styles)(TaskGroup));
